export const REST_ENDPOINT_MODEL_PROTOCOL_TEMPLATE	= '/model/ProtocolTemplate';
export const REST_ENDPOINT_MODEL_TREATMENT_PLAN  	= '/model/TreatmentPlan';
export const REST_ENDPOINT_MODEL_TREATMENT_TEMPLATE	= '/model/TreatmentTemplate';
export const REST_ENDPOINT_MODEL_INSURANCE_PROVIDER = '/model/InsuranceProvider';
export const REST_ENDPOINT_MODEL_PHYSICIAN          = '/model/Physician';
export const REST_ENDPOINT_MODEL_CLINICAL_ASSESSMENTS = '/model/clinicalassessment';

export const REST_ENDPOINT_ABOUT					= '/about';
export const REST_ENDPOINT_SETTINGS					= '/settings';

export const REST_ENDPOINT_CLINICS					= '/pdm/clinics';
export const REST_ENDPOINT_COMBINED_TREATMENT		= '/pdm/combined-treatments';
export const REST_ENDPOINT_CONTACT					= '/pdm/contact';
export const REST_ENDPOINT_CURRENT_USER				= '/pdm/currentuser';
export const REST_ENDPOINT_INDIVIDUAL_TREATMENT		= '/pdm/individual-treatment';
export const REST_ENDPOINT_MT_HISTORY				= '/pdm/mt-history';
export const REST_ENDPOINT_ORGANISATIONS			= '/pdm/organisations';
export const REST_ENDPOINT_PATIENTS					= '/pdm/patients';
export const REST_ENDPOINT_PATIENTS_SEARCH_DEFAULTS	= '/pdm/PatientsSearchDefaults';
export const REST_ENDPOINT_PATIENTS2				= '/pdm/patients2';
export const REST_ENDPOINT_PATIENT_EDIT				= '/pdm/PatientEdit';
export const REST_ENDPOINT_TREATMENT_ARCHIVE		= '/pdm/treatment-archive';
export const REST_ENDPOINT_TREATMENT_HISTORY		= '/pdm/treatment-history';
export const REST_ENDPOINT_TREATMENT_HISTORY_DETAIL	= '/pdm/treatment-history-detail';
export const REST_ENDPOINT_TREATMENT_PLAN			= '/pdm/treatment-plan';
export const REST_ENDPOINT_TREATMENT_TEMPLATES		= '/pdm/treatment-templates';
export const REST_ENDPOINT_USERS					= '/pdm/users';
export const REST_PASSWORD_RESET					= '/pdm/PasswordReset';
export const REST_INSURANCE_PROVIDER			    = '/pdm/insurance-provider';
export const REST_PHYSICIAN					        = '/pdm/physician';
export const REST_NOTES					            = '/pdm/notes';
export const REST_MEDICATIONS					    = '/pdm/medication';
export const REST_CLINICAL_ASSESSMENTS              = '/pdm/clinical-assessment';
export const REST_CLINICAL_ASSESSMENT_TEST          = '/pdm/clinical-assessment-test'; // '/{patientguid}/{ratingscaleguid}'
export const REST_DIAGNOSIS                         = '/pdm/diagnosis';

export const REST_CSV_PATIENT                       = '/csv/patient';

export const REST_PATIENT_REPORT                    = '/PatientReport'; // /{patientguid}
export const REST_PATIENT_DETAILED_REPORT           = '/DetailedPatientReport';
export const REST_TREATER_DETAILED_REPORT           = '/DetailedTreaterReport';

/////////////////////////////////////////////////////////////////////////////////////////////////////////
// Analytics

export const REST_CLINIC_DETAILS                     = '/clinicdetails';
export const REST_CLINIC_TREATMENT_COUNT             = '/clinictreatmentcount';
export const REST_CLINIC_TREATMENT_ACCURACY          = '/clinictreatmentaccuracy';
export const REST_CLINIC_RMT_LEVELS                  = '/clinicrmtlevels';
export const REST_CLINIC_RMT_LEVELS_BY_ETHNICITY     = '/clinicrmtlevelsbyethnicity';
export const REST_CLINIC_RMT_LEVELS_BY_HANDEDNESS    = '/clinicrmtlevelsbyhandedness';
export const REST_CLINIC_RMT_LEVELS_BY_GENDER        = '/clinicrmtlevelsbygender';
export const REST_CLINIC_PROTOCOLS                   = '/clinicprotocols';
export const REST_CLINIC_CLINICAL_ASSESSMENT_SCORES  = '/clinicclinicalassessmentscores';

export const REST_DEVICE_DETAILS                     = '/devicedetails';
export const REST_DEVICE_TREATMENT_COUNT             = '/devicetreatmentcount';
export const REST_DEVICE_TREATMENT_ACCURACY          = '/devicetreatmentaccuracy';
export const REST_DEVICE_RMT_LEVELS                  = '/devicermtlevels';
export const REST_DEVICE_RMT_LEVELS_BY_ETHNICITY     = '/devicermtlevelsbyethnicity';
export const REST_DEVICE_RMT_LEVELS_BY_HANDEDNESS    = '/devicermtlevelsbyhandedness';
export const REST_DEVICE_RMT_LEVELS_BY_GENDER        = '/devicermtlevelsbygender';
export const REST_DEVICE_PROTOCOLS                   = '/deviceprotocols';
export const REST_DEVICE_EVENTS                      = '/deviceevents';

export const REST_DEVICE_SEARCH_DEFAULTS             = '/devicetracability/searchdefaults'
export const REST_DEVICE_SEARCH                      = '/devicetracability/search'

export const REST_ORGANISATION_DETAILS                  = '/organisationdetails';
export const REST_ORGANISATION_TREATMENT_COUNT          = '/organisationtreatmentcount';
export const REST_ORGANISATION_TREATMENT_ACCURACY       = '/organisationtreatmentaccuracy';
export const REST_ORGANISATION_RMT_LEVELS               = '/organisationrmtlevels';
export const REST_ORGANISATION_RMT_LEVELS_BY_ETHNICITY  = '/organisationrmtlevelsbyethnicity';
export const REST_ORGANISATION_RMT_LEVELS_BY_HANDEDNESS = '/organisationrmtlevelsbyhandedness';
export const REST_ORGANISATION_RMT_LEVELS_BY_GENDER     = '/organisationrmtlevelsbygender';
export const REST_ORGANISATION_PROTOCOLS                = '/organisationprotocols';
export const REST_ORGANISATION_CLINICAL_ASSESSMENT_SCORES  = '/organisationclinicalassessmentscores';


export const REST_PATIENT_CLINICAL_ASSESSMENT_SCORES = '/patientclinicalassessmentscores';

export const REST_PATIENT_RMT_LEVELS                 = '/PatientRmtLevels';
export const REST_PATIENT_RMT_LEVELS_BY_ETHNICITY    = '/PatientRmtLevelsByEthnicity';
export const REST_PATIENT_RMT_LEVELS_BY_HANDEDNESS   = '/PatientRmtLevelsByHandedness';
export const REST_PATIENT_RMT_LEVELS_BY_GENDER       = '/PatientRmtLevelsByGender';

export const REST_PATIENT_TREATMENT_ACCURACY         = '/patienttreatmentaccuracy';

export const REST_PATIENT_DETAILS                    = '/patientdetails';

export const REST_TREATER_CLINICAL_ASSESSMENT_SCORES = '/treaterclinicalassessmentscores';

export const REST_TREATER_RMT_LEVELS                 = '/TreaterRmtLevels';
export const REST_TREATER_RMT_LEVELS_BY_ETHNICITY    = '/TreaterRmtLevelsByEthnicity';
export const REST_TREATER_RMT_LEVELS_BY_HANDEDNESS   = '/TreaterRmtLevelsByHandedness';
export const REST_TREATER_RMT_LEVELS_BY_GENDER       = '/TreaterRmtLevelsByGender';

export const REST_TREATER_TREATMENT_ACCURACY         = '/treatertreatmentaccuracy';

export const REST_TREATER_DETAILS                    = '/treaterdetails';

export const REST_ENDPOINT_TREATERS	                 = '/pdm/treaters';

export const REST_ENDPOINT_DEVICES                   = '/pdm/devices';




// Analytics
/////////////////////////////////////////////////////////////////////////////////////////////////////////

